import styled, { keyframes } from "styled-components";
import { COLOR_SYSTEM } from "components/design/design-system";

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const slideIn = keyframes`
  from {
    transform: translateY(-20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

export const ConfirmPopupWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
`;

export const Backdrop = styled.div<{ showBackdrop: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${(props) => (props.showBackdrop ? "rgba(0, 0, 0, 0.3)" : "transparent")};
  animation: ${fadeIn} 0.2s ease-in-out;
`;

export const ConfirmContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${COLOR_SYSTEM.get("Gray")?.[0]};
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  /* width: 480px; */
  min-width: 400px;
  max-width: 90vw;
  max-height: 90vh;
  z-index: 1;
  animation: ${slideIn} 0.3s ease-in-out;
  overflow: hidden;
  position: relative;
`;

export const ConfirmHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 28px 28px 16px 28px;
`;

export const Title = styled.h3`
  margin: 0;
  color: ${COLOR_SYSTEM.get("Gray")?.[800]};
  font-size: 20px;
  font-weight: 600;
`;

export const ConfirmBody = styled.div`
  padding: 8px 28px 28px 28px;
  min-height: 80px;
  max-height: 90vh;
  overflow-y: auto;
  color: ${COLOR_SYSTEM.get("Gray")?.[700]};
  font-size: 16px;
  line-height: 1.5;
`;

export const ConfirmFooter = styled.div<{ buttonCount?: number }>`
  display: grid;
  grid-template-columns: ${(props) =>
    props.buttonCount === 1
      ? "1fr"
      : props.buttonCount === 2
      ? "1fr 1fr"
      : props.buttonCount === 3
      ? "1fr 1fr 1fr"
      : "repeat(auto-fit, minmax(120px, 1fr))"};
  padding: 16px 28px 28px 28px;
  gap: 12px;
`;
